import { parse } from '@lib/parse';
import { TYPES } from '@model/utils/types';
import { Type } from './Type';

export class Any extends Type {
    static toValue(value: any) {
        return parse(value);
    }
}

Any[TYPES.TYPE] = 'any';
